import servicesContent from '@content/services.yaml'
import type { ServicesContent } from '@/types/content'

const content = servicesContent as unknown as ServicesContent

export function Services() {
  return (
    <section id="services" className="sl">
      <div className="svc-intro">
        <div>
          <div className="ey reveal">{content.eyebrow}</div>
          <h2 className="sh2 reveal d2" dangerouslySetInnerHTML={{ __html: content.headline }} />
        </div>
        <p className="slead reveal d3">{content.lead}</p>
      </div>
      <div className="svc-grid">
        {content.cards.map((svc, i) => (
          <div key={svc.num} className={`svc-card reveal${i % 3 === 1 ? ' d2' : i % 3 === 2 ? ' d3' : ''}`}>
            <div className="svc-num">{svc.num}</div>
            <div className="svc-icon">{svc.icon}</div>
            <h3 className="svc-title">{svc.title}</h3>
            <p className="svc-body">{svc.body}</p>
          </div>
        ))}
      </div>
    </section>
  )
}
